export abstract class ApiHelper {
    
    public static addTargetUserId(userId: string): any {
        return {headers: {targetUserId: userId}};
    }
    
    public static addTargetEmployeeId(employeeId: number): any {
        return {headers: {targetEmployeeId: employeeId.toString()}};
    }
}